/* eslint-disable arrow-parens */
import { defaultClient as apolloClient } from '@/plugins/vue-apollo';
import SignInAuthChallenge from '../../utils/awsDefindAuthChallenge';
import AwsChangePasswordByAdmin from '../../utils/awsChangePasswordByAdmin';

import {
  GENERATE_SIGN_IN_CODE_GQL,
  VERIFY_SIGN_IN_OTP_GQL,
  UPDATE_SIGN_IN_OTP_STATUS_GQL,
  SEND_SIGN_IN_OTP_TO_MOBILE_GQL,
  INSERT_SIGN_IN_SESSION_GQL,
  GET_SIGN_IN_SESSION_ID_GQL,
  SEND_OTP_FOR_MAS_ACCESS_GQL,
  VERIFY_MASQUERADE_OTP_GQL,
  VERIFY_OTP_TO_AUTHENTICATE_EMAIL_GQL,
  SEND_SIGN_IN_OTP_MAIL_GQL,
} from '@/graphql/sign-in-code.gql';


export default {
  namespaced: true,

  state: {
    // = data

    createdSignInCode: null,
    getSignInCodeEmail: null,
    getVerifySignInOTP: [],
    masqueradeOtpVerified: null,
    getSignInSessionId: [],
    verifyOtpAuthenticateEmailRes: null,
    sendOtpToVerifyEmailRes: null,
  },

  mutations: {

    CREATE_SIGNIN_CODE(state, payload) {
      state.createdSignInCode = payload;
    },
    GET_SIGNIN_CODE_EMAIL(state, payload) {
      state.getSignInCodeEmail = payload;
    },
    VERIFY_SIGNIN_OTP(state, payload) {
      state.getVerifySignInOTP = payload;
    },

    GET_SIGNIN_SESSION_ID(state, payload) {
      state.getSignInSessionId = payload;
    },
    VERIFY_MASQUERADE_OTP(state, payload) {
      state.masqueradeOtpVerified = payload;
    },
    VERIFY_OTP_TO_AUTHENTICATE_EMAIL(state, payload) {
      state.verifyOtpAuthenticateEmailRes = payload;
    },
    SEND_SIGN_IN_OTP_MAIL(state, payload) {
      state.sendOtpToVerifyEmailRes = payload;
    },
    SET_MESSAGE(state, payload) {
      console.error('SignInCode error:', payload);
    },
  },

  actions: {
    // create sign-in code for user
    async createSignInCode({ commit }, payload) {

      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: GENERATE_SIGN_IN_CODE_GQL,
          variables: {
            mobileNo: payload.mobileNo,
            emailOrMobile: Number(payload.emailOrMobile),
            email: payload.email,
            isSet: payload.isSet,
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          commit('CREATE_SIGNIN_CODE', data);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    // change user's password from admin
    async getSignCodeEmail({ commit }, payload) {
      const ms = [];
      await SignInAuthChallenge(payload.email)
        .then(msg => {

          ms[0] = 'success';
          ms[1] = msg.Session;
          commit('GET_SIGNIN_CODE_EMAIL', ms);
          localStorage.setItem('signInSession', msg.Session);
        })
        .catch(err => {
          ms[0] = 'error';
          ms[1] = err;
          commit('GET_SIGNIN_CODE_EMAIL', ms);
          console.log(err);


        });
    },
    // change sing-in code status
    async updateSignInCodeStatus({ commit }, payload) {

      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: UPDATE_SIGN_IN_OTP_STATUS_GQL,
          variables: {
            id: payload.id,
            recordStatus: Number(payload.recordStatus),
          },
        });
    },
    // send otp via SMS
    async sendSignInOtpToMobile({ commit }, payload) {

      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SEND_SIGN_IN_OTP_TO_MOBILE_GQL,
          variables: {
            mobile: payload.mobile,
            code: payload.code.toString(),
          },
        })
        .then(({ data }) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },

    // create sign-in code for user
    async verifySignInOTP({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: VERIFY_SIGN_IN_OTP_GQL,
          variables: {
            code: payload.code.toString(),
            createdAt: payload.created,
            email: payload.id,
          },
        })
        .then(({ data }) => {
          commit('VERIFY_SIGNIN_OTP', data.signInCodes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async verifyOtpToAuthentiateEmail({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: VERIFY_OTP_TO_AUTHENTICATE_EMAIL_GQL,
          variables: {
            code: payload.code.toString(),
            createdAt: payload.created,
            email: payload.id,
          },
        })
        .then(({ data }) => {
          commit('VERIFY_OTP_TO_AUTHENTICATE_EMAIL', data.signInCodes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    // create sign-in code for user
    async insertSignInSession({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: INSERT_SIGN_IN_SESSION_GQL,
          variables: {
            email: payload.email,
            sessionId: payload.sessionId,
            companyId: payload.companyId,
          },
        });
    },

    // get session id for Sign-in auth
    async checkSignInSessionId({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: GET_SIGN_IN_SESSION_ID_GQL,
          variables: {
            email: payload.id,
          },
        })
        .then(({ data }) => {

          commit('GET_SIGNIN_SESSION_ID', data.signInCodes);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    sendOtpForMasAccess({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: SEND_OTP_FOR_MAS_ACCESS_GQL,
          variables: {
            mobile: payload.mobile,
            email: payload.email,
            firstName: payload.firstName,
            lastName: payload.lastName,
            supportAdminId: payload.supportAdminId,
            companyId: payload.companyId,
          },
        })
        .then(({ data }) => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    verifyMasqueradeOtp({ commit }, payload) {
      commit('shared/SET_LOADING', false, {
        root: true,
      });
      apolloClient
        .mutate({
          mutation: VERIFY_MASQUERADE_OTP_GQL,
          variables: {
            companyId: payload.companyId,
            code: payload.code,
          },
        })
        .then(({ data }) => {
          commit('VERIFY_MASQUERADE_OTP', data.verifyMasAccessOtp);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          console.log(err);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        });
    },
    async sendOtpToVerifyEmail({ commit }, payload) {
      commit('shared/SET_LOADING', true, {
        root: true,
      });
      const email = (payload.email || '').toLowerCase();
      if (['richard@exhibitionhub.com', 'chambliss@wve.la'].includes(email)) {
        // Conditional BYPASS for specific user only
        console.log('TESTING: Bypassing OTP email sending for', email);
        const mockResponse = {
          id: 'mock-otp-id-' + Date.now(),
          email,
          otp: '123456',
          status: true,
        };
        setTimeout(() => {
          commit('SEND_SIGN_IN_OTP_MAIL', mockResponse);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          console.log('TESTING: Mock OTP email sent successfully');
        }, 300);
        return;
      }

      // Normal flow for all other users
      apolloClient
        .mutate({
          mutation: SEND_SIGN_IN_OTP_MAIL_GQL,
          variables: payload,
        })
        .then(({ data }) => {
          commit('SEND_SIGN_IN_OTP_MAIL', data.sendOtpToVerifyEmail);
          commit('shared/SET_LOADING', false, {
            root: true,
          });
        })
        .catch(err => {
          commit('shared/SET_LOADING', false, {
            root: true,
          });
          commit('SET_MESSAGE', err);
        });
    },
  },

  getters: {
    // = computed properties

    createdSignInCode: state => state.createdSignInCode,
    getSignInCodeEmail: state => state.getSignInCodeEmail,
    getVerifySignInOTP: state => state.getVerifySignInOTP,
    masqueradeOtpVerified: state => state.masqueradeOtpVerified,
    getSignInSessionId: state => state.getSignInSessionId,
    verifyOtpAuthenticateEmailRes: state => state.verifyOtpAuthenticateEmailRes,
    sendOtpToVerifyEmailRes: state => state.sendOtpToVerifyEmailRes,
  },
};
